import React, { useState } from "react";
import aboutBg from "../../assets/img/bg/7.png";
import aboutBgVDO from "../../assets/img/bg/18.mp4";
import aboutImg1 from "../../assets/img/about/2.png";
import aboutImg2 from "../../assets/img/about/3.png";
import aboutImg3 from "../../assets/img/banner/5.svg";
import aboutImg4 from "../../assets/img/about/1.png";
import aboutImg5 from "../../assets/img/icon/2.png";
import aboutImg6 from "../../assets/img/icon/3.png";
import aboutImg7 from "../../assets/img/icon/4.png";
import aboutImg8 from "../../assets/img/service-icon/1.png";
import aboutImg9 from "../../assets/img/service-icon/2.png";
import aboutImg10 from "../../assets/img/service-icon/3.png";
import aboutImg11 from "../../assets/img/bg/5.png";
import aboutImg12 from "../../assets/img/bg/4.png";
import aboutImg13 from "../../assets/img/about/6.png";
import aboutImg14 from "../../assets/img/banner/2.png";
import svg5 from "../../assets/img/icon/5.svg";
import svg6 from "../../assets/img/icon/6.svg";
import svg7 from "../../assets/img/icon/7.svg";
import svg8 from "../../assets/img/icon/8.svg";
import svg9 from "../../assets/img/icon/9.svg";
import svg10 from "../../assets/img/icon/10.svg";
import svg11 from "../../assets/img/icon/11.svg";
import svg12 from "../../assets/img/icon/12.svg";
import { FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sendContactQuery } from "../../Utils/SendMail";
// Services data
const services = [
  {
    id: 1,
    imgSrc: aboutImg8,
    title: "Mobile App Development",
    description:
      "We specialize in developing high-quality mobile apps for both iOS and Android platforms. Our apps are designed for seamless performance, intuitive user experience, and tailored to meet your specific business needs.",
    link: "service-details.html",
  },
  {
    id: 2,
    imgSrc: aboutImg9,
    title: "Content Marketing",
    description:
      "We deliver content marketing strategies that create engaging, high-quality content tailored to your audience, boosting brand awareness, driving customer engagement, and generating measurable results to grow your business effectively.",
    link: "service-details.html",
  },
  {
    id: 3,
    imgSrc: aboutImg10,
    title: "E-commerce Solutions",
    description:
      "We offer end-to-end e-commerce solutions, creating scalable online stores with seamless user experience, secure payment integration, and ongoing support to help your business grow and thrive online.",
    link: "service-details.html",
  },
];

// Counters data
const counters = [
  {
    id: 1,
    imgSrc: svg5,
    count: "200",
    description: "Team member",
  },
  {
    id: 2,
    imgSrc: svg6,
    count: "10k",
    description: "Happy Clients",
  },
  {
    id: 3,
    imgSrc: svg7,
    count: "200",
    description: "Projects Completed",
  },
  {
    id: 4,
    imgSrc: svg8,
    count: "200",
    description: "Awards Won",
  },
];

// Work processes data
const workProcesses = [
  {
    id: 1,
    imgSrc: svg9,
    processCount: "Work 01",
    title: "Software Research",
    description:
      "Firstly, we gather all requirements from the client, then conduct thorough research to design and develop the optimal software solution.",
  },
  {
    id: 2,
    imgSrc: svg10,
    processCount: "Work 02",
    title: "Create Programs",
    description:
      "We create custom programs tailored to your specific needs, ensuring they are efficient, reliable, and aligned with your business objectives.",
  },
  {
    id: 3,
    imgSrc: svg11,
    processCount: "Work 03",
    title: "Develop Software",
    description:
      "We develop high-quality software solutions, designed to meet your unique requirements, ensuring functionality, scalability, and a seamless user experience.",
  },
  {
    id: 4,
    imgSrc: svg12,
    processCount: "Work 04",
    title: "Shop Software",
    description:
      "We offer tailored shop software solutions that streamline your business operations, manage inventory, process sales efficiently, and enhance customer experience.",
  },
];

function AboutCompany() {
  const [contactForm, setContactForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setContactForm({ ...contactForm, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, phone, subject, message } = contactForm;

    if (!name || !email || !phone || !subject || !message) {
      toast.error("All fields are required", {
        position: "top-center",
      });
    } else {
      sendContactQuery(name, email, phone, message, subject)
        .then((responseMessage) => {
          toast.success(responseMessage, {
            position: "top-center",
            autoClose: 2000,
          });
        })
        .catch((errorMessage) => {
          toast.error(errorMessage, {
            position: "top-center",
            autoClose: 2000,
          });
        });
      setContactForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="breadcrumb-area bg-cover">
        <video autoPlay muted loop className="video-background">
          <source src={aboutBgVDO} type="video/mp4" />
        </video>
        <div className="container">
          <div className="breadcrumb-inner">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <h2 className="page-title">About Us</h2>
              </div>
              <div className="col-lg-6 text-lg-end">
                <ul className="page-list">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <IoIosArrowForward />
                  <li>About Us</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-area pd-top-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="about-thumb-inner pe-xl-5 me-xl-5">
                <img
                  className="animate-img-1 top_image_bounce"
                  src={aboutImg1}
                  alt="img"
                />
                <img
                  className="animate-img-2 left_image_bounce"
                  src={aboutImg2}
                  alt="img"
                />
                <img
                  className="animate-img-3 top_image_bounce"
                  src={aboutImg3}
                  alt="img"
                />
                <img className="main-img" src={aboutImg4} alt="img" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="section-title">
                <h6 className="sub-title">ABOUT US</h6>
                <h2 className="title">
                  IT is a critical component of <span>modern</span> businesses
                </h2>
                <p className="content mb-4 mb-xl-5">
                  At TechVoyageLab, we specialize in delivering innovative IT
                  solutions, including software development, web design, and
                  cloud services. Our expert team is dedicated to helping
                  businesses achieve success through technology, tailored to
                  meet each client's unique needs.
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="single-about-inner">
                      <div className="thumb mb-3">
                        <img src={aboutImg5} alt="img" />
                      </div>
                      <div className="details">
                        <h5>Our Ambition</h5>
                        <p>
                          Our ambition is to lead in IT innovation, empowering
                          businesses with cutting-edge solutions and driving
                          digital transformation globally.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="single-about-inner">
                      <div className="thumb mb-3">
                        <img src={aboutImg6} alt="img" />
                      </div>
                      <div className="details">
                        <h5>Our Purpose</h5>
                        <p>
                          Our purpose is to empower businesses with innovative
                          technology solutions, driving growth, and transforming
                          challenges into opportunities for success.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="service-area bg-relative pd-top-100">
        <img
          className="position-bottom-left top_image_bounce"
          src={aboutImg7}
          alt="img"
        />
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">CREATIVE SERVICES</h6>
            <h2 className="title">
              Your Partner In <span>Digital</span> Success
            </h2>
          </div>
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 abouticons">
                <div className="single-service-inner text-center">
                  <div className="thumb">
                    <img src={service.imgSrc} alt="img" />
                  </div>
                  <div className="details">
                    <h5>{service.title}</h5>
                    <p>{service.description}</p>
                    {/* <p className="btn btn-border-base">
                      Touch More <FaPlus />
                    </p> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "8px",
          marginBottom: "15px",
        }}
        className="loadMoreBtn_con"
      >
        <Link to={"/services"}>
          <button>Load More</button>
        </Link>
      </div>

      <div
        className="counter-area bg-relative bg-cover pd-top-110 pd-bottom-100"
        style={{ backgroundImage: `url(${aboutImg11})` }}
      >
        <div className="container pd-bottom-90">
          <div className="row iconsCon">
            {counters.map((counter) => (
              <div key={counter.id} className="col-lg-3 abouticons">
                <div className="single-counter-inner">
                  <div className="thumb">
                    <img src={counter.imgSrc} alt="img" />
                  </div>
                  <h2 className="text-white mt-4 mb-2">
                    <span className="counter">{counter.count}</span>+
                  </h2>
                  <p className="text-white">{counter.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="contact-area">
        <div className="container">
          <div className="contact-inner-1">
            <img
              className="top_image_bounce animate-img-1"
              src={aboutImg14}
              alt="img"
            />
            <img
              className="top_image_bounce animate-img-2"
              src={aboutImg13}
              alt="img"
            />
            <div className="row">
              <div className="col-lg-8">
                <img className="w-100" src={aboutImg12} alt="img" />
              </div>
              <div className="col-lg-4">
                <div className="section-title mb-0">
                  <h6 className="sub-title">GET IN TOUCH</h6>
                  <h2 className="title">
                    Bringing Your <span>Vision</span> To Life
                  </h2>
                  <p className="content">
                    For your car we will do everything advice design in us
                    repairs and maintenance. We are the some preferred.
                  </p>

                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="single-input-inner style-border">
                          <input
                            type="text"
                            placeholder="Your Name"
                            name="name"
                            value={contactForm.name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="single-input-inner style-border">
                          <input
                            type="email"
                            placeholder="Your Email"
                            name="email"
                            value={contactForm.email}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="single-input-inner style-border">
                          <input
                            type="text"
                            placeholder="Your Phone"
                            name="phone"
                            value={contactForm.phone}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="single-input-inner style-border">
                          <input
                            type="text"
                            placeholder="Your Subject"
                            name="subject"
                            value={contactForm.subject}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="single-input-inner style-border">
                          <textarea
                            placeholder="Message"
                            name="message"
                            value={contactForm.message}
                            onChange={handleInputChange}
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12">
                        <button
                          className="btn btn-black mt-0 w-100 border-radius-5"
                          type="submit"
                          style={{ backgroundColor: "#3C6BFD" }}
                        >
                          Submit now
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="work-process-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="section-title text-center">
            <h6 className="sub-title">OUR SIMPLE PROCESS</h6>
            <h2 className="title">
              World <span>Best Step</span> Our IT Process
            </h2>
          </div>
          <div className="row">
            {workProcesses.map((process) => (
              <div key={process.id} className="col-lg-3 col-md-6 worksDetails">
                <div className="single-work-process-inner">
                  <div className="thumb mb-3">
                    <img src={process.imgSrc} alt="img" />
                  </div>
                  <div className="details">
                    <p className="process-count">{process.processCount}</p>
                    <h5 className="mb-3">{process.title}</h5>
                    <p className="content">{process.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutCompany;
